import { Injectable, computed, inject, signal } from '@angular/core';
import { CookieService } from './cookie.service';

const SIDEBAR_COLLAPSED_COOKIE = 'sidebar_collapsed';
const COOKIE_EXPIRY_DAYS = 365;

@Injectable({ providedIn: 'root' })
export class SidebarStateService {
  private readonly cookieService = inject(CookieService);
  private readonly preferenceVersion = signal(0);
  private hydrated = false;
  private preference = false;

  readonly preferenceCollapsed = computed(() => {
    this.preferenceVersion();
    return this.currentPreference();
  });

  togglePreference(): boolean {
    const nextPreference = !this.currentPreference();
    this.preference = nextPreference;
    this.hydrated = true;
    this.preferenceVersion.update(version => version + 1);
    this.cookieService.setCookie(
      SIDEBAR_COLLAPSED_COOKIE,
      String(nextPreference),
      COOKIE_EXPIRY_DAYS,
      {
        crossSubdomain: true,
      }
    );
    return nextPreference;
  }

  private currentPreference(): boolean {
    if (!this.hydrated) {
      this.hydrated = true;
      this.preference = this.readPreference();
    }
    return this.preference;
  }

  private readPreference(): boolean {
    return this.cookieService.getCookie(SIDEBAR_COLLAPSED_COOKIE) === 'true';
  }
}
